import React, { createContext, useContext } from "react";

const MessageContext = createContext();

export const PMEMessageProvider = ({ children, messages }) => {
  const cachedMessages = React.useMemo(() => messages, []);
  return <MessageContext value={cachedMessages}>{children}</MessageContext>;
};

export const usePMEMessages = () => useContext(MessageContext);
